export const Text = {
  variants: {
    rubik: {
      fontFamily: 'Rubik Glitch',
      textShadow: '-2px  0px 0px #FFFF3F',
      letterSpacing: '3px',
    },
    rubikGray: {
      fontFamily: 'Rubik Glitch',
      textShadow: '-2px  0px 0px #000000',
      letterSpacing: '3px',
    },
    sofia: {
      fontFamily: 'Sofia Sans',
    },
  },
}
